<!--Email button-->
<div class="email">

  <button mat-icon-button
          aria-label="Email Contact Button"
          [disabled]="!bestEmail || isDoNotContact(bestEmail)"
          (click)="togglePopover('email')">
    <mat-icon fontSet="fal fa-fw"
              fontIcon="fa-envelope"></mat-icon>
  </button>

  <div class="detailPop show"
       *ngIf="bestEmail && visiblePopover === 'email'"
       [ngClass]="{ show : visiblePopover === 'email' }">
    <span class="detailPop__content">{{bestEmail?.email}} ({{bestEmail?.emailType}})</span>
    <div class="detailPop__actions flex flexJustify--between">
      <button class="detailPop__btn col__ col__xs--50"
              type="button"
              [cdkCopyToClipboard]="bestEmail?.email"
              (cdkCopyToClipboardCopied)="copied()">
        <i class="far fa-clipboard"></i>Copy</button>
      <a class="detailPop__btn col__ col__xs--50"
        (click)="loadLogConversationModal(bestEmail)"
         href="mailto:{{bestEmail?.email}}">
        <i class="far fa-external-link-square"></i>Email</a>
    </div>
  </div>

</div>

<!--Phone button-->
<div class="phone">
  <button mat-icon-button
          aria-label="Phone Contact Button"
          [disabled]="!bestPhone || isDoNotContact(bestPhone)"
          (click)="togglePopover('call')">
    <mat-icon fontSet="fal fa-fw"
              fontIcon="fa-phone"></mat-icon>
  </button>

  <div class="detailPop show"
       *ngIf="bestPhone && visiblePopover === 'call'">
    <span class="detailPop__content">{{bestPhone?.number | phone}}
      {{bestPhone?.ext ? 'Ext. ' + bestPhone.ext : ''}} ({{bestPhone?.numberType}})</span>
    <div class="detailPop__actions flex flexJustify--between">
      <button class="detailPop__btn col__ col__xs--50"
              type="button"
              [cdkCopyToClipboard]="(bestPhone.number | phone) + (bestPhone?.ext ? ' Ext. ' + bestPhone.ext : '')"
              (cdkCopyToClipboardCopied)="copied()">
        <i class="far fa-clipboard"></i>Copy</button>
      <a class="detailPop__btn col__ col__xs--50"
         href="tel:{{bestPhone?.number}}"
         (click)="loadLogConversationModal(bestPhone)"
         >
        <i class="far fa-external-link-square"></i>Call</a>
    </div>
  </div>

</div>

<!-- sms button -->
<div class="text">
  <button mat-icon-button
          aria-label="Text Messsage Contact Button"
          [disabled]="!bestPhone || isDoNotContact(bestPhone) || (bestPhone && bestPhone.numberType != 'cell')"
          (click)="togglePopover('message')">
    <mat-icon fontSet="fal fa-fw"
              fontIcon="fa-comment-alt"></mat-icon>
  </button>

  <div class="detailPop show"
       *ngIf="bestPhone && visiblePopover === 'message'">
    <span class="detailPop__content">{{bestPhone?.number | phone}} ({{bestPhone?.numberType}})</span>
    <div class="detailPop__actions flex flexJustify--between">
      <button class="detailPop__btn col__ col__xs--50"
              type="button"
              [cdkCopyToClipboard]="bestPhone?.number | phone"
              (cdkCopyToClipboardCopied)="copied()">
        <i class="far fa-clipboard"></i>Copy</button>
      <button class="detailPop__btn col__ col__xs--50"
              (click)="sendSMS(bestPhone)">
        <i class="far fa-external-link-square"></i>Message</button>
    </div>
  </div>

</div>

<!-- address button -->
<div class="address">

  <button mat-icon-button
          aria-label="Address Contact Button"
          [disabled]="!bestAddress?.streetAddress || isDoNotContact(bestAddress)"
          (click)="togglePopover('address')">
    <mat-icon fontSet="fal fa-fw"
              fontIcon="fa-map-marker-alt"></mat-icon>
  </button>


  <div class="detailPop show"
       *ngIf="visiblePopover === 'address'">
    <span class="detailPop__content">
      <full-address [address]="bestAddress"
                    [displayAddressType]="true"></full-address>
    </span>
    <div class="detailPop__actions flex flexJustify--between">
      <button class="detailPop__btn col__ col__xs--50"
              type="button"
              [cdkCopyToClipboard]="bestAddress | address"
              (cdkCopyToClipboardCopied)="copied()">
        <i class="far fa-clipboard"></i>Copy</button>
      <a href="https://www.google.com/maps/search/?api=1&query={{bestAddress | address}}"
         target="_blank"
         (click)="loadLogConversationModal(null)"
         class="detailPop__btn col__ col__xs--50">
        <i class="far fa-external-link-square"></i>Map
      </a>
    </div>
  </div>

</div>
